import { render, staticRenderFns } from "./homePage.vue?vue&type=template&id=510124a8&"
import script from "./homePage.vue?vue&type=script&lang=js&"
export * from "./homePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports